<div class="d-flex position-absolute" *ngIf="show">
    <i class="fas fa-exclamation-triangle fa-xs text-danger ml-1 align-self-center"></i>
    <span class="ml-2">{{text}}</span>
</div>